export default (theme) => ({
  floatingActionButton: {
    position: "fixed",
    right: 20,
    bottom: 20,
  },
  container: {
    padding: 20,
    height: "calc(100vh - 136px)",
    overflow: "scroll",
  },
  page: {
    height: "calc(100vh - 48px)",
    background: "red",
    position: "relative",
  },
  tabs: {
    background: "white",
  },
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  tabsRoot: {
    background: theme.palette.background.paper,
  },
  tabRoot: {
    textTransform: "initial",
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:hover": {
      color: theme.palette.text,
      opacity: 1,
    },
    "&$tabSelected": {
      color: theme.palette.text,
      fontWeight: theme.typography.fontWeightMedium,
    },
    "&:focus": {
      color: theme.palette.text,
    },
  },
  tabSelected: {},
  typography: {
    padding: theme.spacing.unit * 3,
  },
  header: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
  },
  headerSearch: {
    background: theme.palette.type === "dark" ? "black" : "#D0D8E1",
    backgroundPosition: "center",
    backgroundSize: "cover",
    height: "50vh",
    maxHeight: 500,
  },
  banner: {
    background: theme.palette.type === "dark" ? "#212121" : "#1C2833",
    color: "white",
    position: "relative",
  },
});
